import React, {Component} from 'react'
import moment from 'moment'

import contrassegnoLogo from '../../../assets/logo-contrassegno.png'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import Modal from 'react-responsive-modal'
import {Field, reduxForm} from 'redux-form'
import VehicleSelectFormComponent from '../../../components/redux-form/VehicleSelectFormComponent'

const TextUser = (props) => <div style={props.style} className={props.bold ? 'text-bold-user' : 'text-regular-user'}>{props.children}</div> 

class WaitingLists extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      errors: null,
      waitingLists: [],
      showParticipationModal: false,
      selectedWaitingList: null,
      selectedVehicles: [],
      submitting: false,
      myPartecipations: []
    }
  }

  async componentDidMount () {
    this.setState({loading: true})
    await this.fetchInitialData()
    this.setState({loading: false})
  }

  fetchInitialData = async () => {
    try {
      const results = await Promise.all([
        SostaOnlineApiService.fetchUserMe(),
        SostaOnlineApiService.fetchVehicleOwnershipTypes(),
        SostaOnlineApiService.fetchVehiclePowerSupplies(),
        SostaOnlineApiService.fetchUserWaitingLists(),
        SostaOnlineApiService.fetchUserMyPartecipationWaitingLists(),
        SostaOnlineApiService.fetchUserWaitingListSubscriptionsCount()
      ])
      const { data: user } = results[0]
      this.setState({
        user: user,
        vehicleOwnershipTypes: results[1].data,
        vehiclePowerSupplies: results[2].data,
        waitingLists: !results[3].data ? [] : results[3].data,
        myPartecipations: !results[4].data ? [] : results[4].data,
        partecipationCount: !results[5].data ? 0 : results[5].data.total
      })
      console.log(results[5])
    } catch (e) {
      this.setState({errors: 'errore imprevisto, riprova più tardi'})
    }
  }

  isUserBelongsToCategory = (categoryId) => {
    if (!this.props.user.categories) {
      return false
    }

    let filtered = this.props.user.categories.filter(item => {
      return item.id === categoryId
    })

    return filtered.length > 0
  }

  showParticipationModal = (waitingList) => {
    this.setState({
      showParticipationModal: true,
      selectedWaitingList: {
        ...waitingList,
        parkTicketPrice: this.getParkTicketPrice(waitingList)
      },
      selectedVehicles: [{}]
    })
  }

  hideParticipationModal = () => {
    this.setState({
      showParticipationModal: false,
      selectedWaitingList: null,
      selectedVehicles: []
    })
  }

  onVehicleRemove = (index) => {
    if (this.state.selectedVehicles.length > 1) {
      this.setState({selectedVehicles: this.state.selectedVehicles.filter((_, i) => i !== index)})
    }
  }

  onVehicleAdd = () => {
    if (this.state.selectedVehicles.length >= this.state.selectedWaitingList.parkTicketType.vehiclesLimit) {
      return
    }
    this.setState({selectedVehicles: [...this.state.selectedVehicles, {}]})
  }

  onVehicleSelected = (vehicle, index) => {
    let newSelectedVehicles = [...this.state.selectedVehicles]
    newSelectedVehicles[index] = vehicle
    this.setState({selectedVehicles: newSelectedVehicles})
  }

  onVehiclePowerSupplyChange = (e, index) => {
    let newSelectedVehicles = [...this.state.selectedVehicles]
    newSelectedVehicles[index].VehiclePowerSupply = {id: e.target.value}
    this.setState({selectedVehicles: newSelectedVehicles})
  }

  onVehicleOwnershipTypeChange = (e, index) => {
    let newSelectedVehicles = [...this.state.selectedVehicles]
    newSelectedVehicles[index].VehicleOwnershipType = {id: e.target.value}
    this.setState({selectedVehicles: newSelectedVehicles})
  }

  onSubmit = async (values) => {
    const { submitting, selectedVehicles, selectedWaitingList } = this.state

    var invalidVehicles = selectedVehicles.filter( v => v.id == null )

    if ( invalidVehicles != null && invalidVehicles.length > 0  ) {
      this.setState({
        errors: 'Veicolo selezionato non valido',
        submitting: false
      })
      return
    }
    
    if (submitting) {
      return
    }

    try {
      this.setState({submitting: true, errors: null})
      const response = await SostaOnlineApiService.subscribeToWaitingList(
        selectedWaitingList.id,
        selectedVehicles
      )
      if (response.result !== 'ok') {
        this.setState({
          errors: 'Errore durante la partecipazione',
          submitting: false
        })
      } else {
        this.setState({
          submitting: false
        })
        this.hideParticipationModal()
        await this.fetchInitialData()
      }
    } catch (e) {
      console.log(e)
      this.setState({submitting: false, errors: e.error || 'Errore imprevisto durante la partecipazione'})
    }
  }

  onWaitingListPay = (item) => {
    this.props.history.push('/user-area/pay/waitingListParkTicket/' + item.id)
  }

  getParkTicketPrice = (waitingList) => {
    return Math.min(...waitingList.Categories.map(c => c.WaitingListCategories.parkTicketPrice))
  }

  render () {
    const {
      waitingLists,
      selectedWaitingList,
      showParticipationModal,
      selectedVehicles,
      vehiclePowerSupplies,
      vehicleOwnershipTypes,
      user,
      errors,
      myPartecipations,
      partecipationCount
    } = this.state
    return (
      <div>
        <div className="row">
          <div className="col-md-7">
            <div className="panel panel-default panel-border-login">
              <h2 className="login-title">
                PRENOTAZIONI
              </h2>
              <div className="panel-body">
                <div className="col-md-3"><img className="user-admin-logo" src={contrassegnoLogo} /></div>
                <div className="col-md-9 text-left">
                  <TextUser>
                    PRENOTAZIONI ATTIVE:
                  </TextUser>
                  {waitingLists.length === 0 && (
                    <div className="card">
                      <div className="caption">
                        <div className="col-md-12">
                          <h4 className="text-muted" style={{marginTop: 46}}>
                            Nessuna prenotazione sottoscrivibile
                          </h4>
                        </div>
                      </div>
                    </div>
                  )}
                  {waitingLists.map((item, index) => {
                    let parkTicketPrice = this.getParkTicketPrice(item)

                    return (
                      <div
                        key={`active-waitinglist-${item.id}`}
                        style={{marginTop: 10}}
                        className="user-card"
                      >
                        <div className="user-card-head-a">
                          <h5 className="user-card-title">
                            <strong>PRENOTAZIONE PER</strong>: {item.parkTicketType.name.toUpperCase()}
                          </h5>
                        </div>
                        <div className="user-card-body" style={{paddingBottom: 10}}>
                          <div>
                            <span>Valido dal <strong>{moment(item.markStartDate).startOf('month').format('L')}</strong> al <strong>{moment(item.markStartDate).add(item.numberOfMonths > 1 ? item.numberOfMonths - 1 : 0, 'months').endOf('month').format('L')}</strong></span>
                          </div>
                          <div>
                            <strong>Prezzo:</strong> € {parkTicketPrice > 0 ? Number(parkTicketPrice).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0,00'}
                          </div>
                        </div>
                        <div className="border-div" />
                        <div className="user-card-footer" style={{paddingTop: 10}}>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <strong>Scadenza:</strong> {moment(item.endDate).fromNow()}
                          </div>
                          <div style={{padding: 0, marginBottom: 15}} className="col-md-12">
                            <strong>Abbonamenti disponibili:</strong> {item.availabilityNumber - item.subscriptions}
                          </div>
                          {item.Subscriptions.length > 0 ? (
                            <div>
                              <div>Hai partecipato a questa lista il: <strong>{moment(item.Subscriptions[0].createdAt).format('L')}</strong> alle: <strong>{moment(item.Subscriptions[0].createdAt).format('LT')}</strong></div>
                              <div><strong>ID partecipazione:</strong> {item.Subscriptions[0].id}</div>
                            </div>
                          ) : item.subscriptions >= item.availabilityNumber ? (
                            <div className="text-danger">
                              Questa lista d'attesa non ha più abbonamenti disponibili.
                            </div>
                          ) : partecipationCount > 0 ? (
                            <div className="text-danger">
                              Non puoi partecipare a questa lista in quanto hai già una partecipazione attiva
                            </div>
                          ) : (
                            <a className="btn-download-user" onClick={() => this.showParticipationModal(item)}>
                              PRENOTA ORA
                            </a>
                          )}
                        </div>
                      </div>
                    )
                  })}
                  <div style={{marginTop: 40}}>
                    <TextUser style={{marginBottom: 20}}>
                      PRENOTAZIONI CONCLUSE CON SUCCESSO:
                    </TextUser>
                    {myPartecipations.length === 0 && (
                      <div className="card">
                        <div className="caption">
                          <div className="col-md-12">
                            <h4 className="text-muted" style={{marginTop: 46}}>
                              Nessuna prenotazione conclusa con successo
                            </h4>
                          </div>
                        </div>
                      </div>
                    )}
                    {myPartecipations.map((item, index) => {
                      return (
                        <div key={`my-partecipation-${index}`} className={'user-card-btn-2'}>
                          <div className="row" style={{display: 'flex'}}>
                            <div className="col-md-9 text-left">
                              <div><strong>{item.parkTicketType.name}</strong></div>
                              <small>
                                Valido dal <strong>{moment(item.markStartDate).startOf('month').format('L').toUpperCase()}</strong>{' al '}
                                <strong>
                                  {moment(item.markStartDate).startOf('month').add(item.numberOfMonths > 1 ? item.numberOfMonths - 1 : 0, 'months').endOf('month').format('L')}
                                </strong>
                              </small>
                            </div>
                            <div style={{paddingTop: 10}} className="col-md-3">
                              <a onClick={() => this.onWaitingListPay(item)} className="btn-download-user">ACQUISTA</a>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-md-offset-1 col-information-user hidden-xs hidden-sm">
            <div className="information-container">
              <div style={{marginLeft: 30}}>
                <div style={{marginTop: 15, marginBottom: 10}}>
                  <TextUser bold>PRENOTAZIONI</TextUser>
                  <TextUser>
                    LE PRENOTAZIONI PERMETTONO DI OTTENERE ABBONAMENTI PER UN NUMERO LIMITATO DI PERSONE.<br />
                    QUANDO UNA LISTA È ATTIVA E SOTTOSCRIVIBILE PUOI ISCRIVERTI CLICCANDO SUL PULSANTE "PRENOTA ORA".<br />
                  </TextUser>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          open={showParticipationModal}
          onClose={this.hideParticipationModal}
          showCloseIcon
          closeOnEsc={false}
          closeOnOverlayClick={false}
          classNames={{modal: 'container'}}
        >
          <form onSubmit={this.props.handleSubmit(values => {
            this.onSubmit(values)
          })}>
            <h3>Prenota Abbonamento</h3>
            {selectedWaitingList ? (
              <React.Fragment>
                <div className="row">
                  <div className="col-md-7 col-xs-12">
                    <div className="user-card">
                      <div className="user-card-head-a">
                        <h5 className="user-card-title">
                          {selectedWaitingList.parkTicketType.name}
                        </h5>
                      </div>
                      <div className="user-card-body">
                        <div className="row">
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-6">
                            <strong>{selectedWaitingList.Categories[0].label.toUpperCase()}</strong>
                          </div>
                          <div style={{padding: 0}} className="col-md-6 text-right">
                            ZON{selectedWaitingList.parkTicketType.Areas.length > 1 ? 'E' : 'A'}: <strong>{selectedWaitingList.parkTicketType.Areas.map(item => item.code + ' ')}</strong>
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>TARG{selectedVehicles.length > 1 ? 'HE' : 'A'}: <strong>{selectedVehicles.length === 0 && '...'}{selectedVehicles.map(item => item.plate_number ? item.plate_number.toUpperCase() + ' ' : '')}</strong></span>
                          </div>
                        </div>
                      </div>
                      <div className="border-div" />
                      <div className="user-card-footer">
                        <div className="row">
                          <div style={{padding: 0, marginTop: 10, marginBottom: 5}} className="col-md-12">
                            <span>EMESSO IL: <strong>...</strong></span>
                          </div>
                          <div style={{padding: 0, marginBottom: 5}} className="col-md-12">
                            <span>VALIDO DAL <strong>{moment(selectedWaitingList.markStartDate).startOf('month').format('L')}</strong> AL <strong>{moment(selectedWaitingList.markStartDate).add(selectedWaitingList.numberOfMonths > 1 ? selectedWaitingList.numberOfMonths - 1 : 0, 'months').endOf('month').format('L')}</strong></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5">
                    <p>
                      Da qui puoi puoi partecipare alla lista d'attesa per l'abbonamento: <strong>{selectedWaitingList.parkTicketType.name}</strong>.
                    </p>
                    {selectedWaitingList.parkTicketPrice && selectedWaitingList.parkTicketPrice > 0 ? (
                      <p>
                        L'abbonamento ha un costo totale di: <strong>€ {Number(selectedWaitingList.parkTicketPrice).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</strong>
                      </p>
                    ) : <p>L'abbonamento ha un costo totale di: <strong>€ 0,00</strong></p>}
                  </div>

                </div>
                <div className="row">
                  <div className="col-md-12">
                    <p>Inserisci qui di seguito il/i veicolo/i per il quale intendi attivare l'abbonamento.</p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 text-left">
                    <a style={{margin: '0 10px 0 17px'}} type="button" className="btn btn-info btn-xs" onClick={this.onVehicleAdd}>
                      Aggiungi Veicolo
                    </a>
                    <span className={selectedVehicles.length >= selectedWaitingList.parkTicketType.vehiclesLimit ? 'text-danger' : 'text-primary'}>
                      {' Veicoli Utilizzati: ' + selectedVehicles.length} / {selectedWaitingList.parkTicketType.vehiclesLimit}
                    </span>
                  </div>
                  {selectedVehicles.map((item, index) => {
                    return (
                      <div className="col-md-12" key={'vehicle-' + index} style={{padding: '20px'}}>
                        <div className="col-md-3 text-left">
                          <label>Targa D</label>
                          <Field
                            component={VehicleSelectFormComponent}
                            onValueChange={(value) => this.onVehicleSelected(value, index)}
                            vehicles={user.vehicles}
                            required
                            name={'vehicle' + index}
                            newveicle={false}
                            className="resident-login" />
                        </div>

                        { /* NON SI POSSONO AGGIUNGERE NUOVI VEICOLO IN QUESTA SEZIONE */ }
                        { /*!item.id && (
                          <div className="col-md-4 text-left">
                            <label>Tipologia di alimentazione</label>
                            <Field
                              onChange={(e) => this.onVehiclePowerSupplyChange(e, index)}
                              required
                              name={'powerSupply' + index}
                              component="select"
                              className="form-control sel1-control">
                              <option value={''}>Seleziona tipo di alimentazione</option>
                              {item.plate_number ? vehiclePowerSupplies.map((item, index) => (
                                <option key={index} value={item.id}>{item.name}</option>
                              )) : <option value={''}>Seleziona una targa prima</option>}
                            </Field>
                          </div>
                              ) */}

                        { /*!item.id && (
                          <div className="col-md-4 text-left">
                            <label>Tipologia di proprietà</label>
                            <Field
                              onChange={(e) => this.onVehicleOwnershipTypeChange(e, index)}
                              required
                              name={'ownershipType' + index}
                              component="select"
                              className="form-control sel1-control">
                              <option value={''}>Seleziona tipo di proprietà</option>
                              {item.plate_number ? vehicleOwnershipTypes.map((item, index) => (
                                <option key={index} value={item.id}>{item.name}</option>
                              )) : <option value={''}>Seleziona una targa prima</option>}
                            </Field>
                          </div>
                              ) */}

                        {item.id && (
                          <div className="col-md-4 text-left">
                            <label>Tipologia di alimentazione</label>
                            <div style={{marginTop: 12}}>
                              <h4>{item.VehiclePowerSupply.name}</h4>
                            </div>
                          </div>
                        )}

                        {item.id && (
                          <div className="col-md-4 text-left">
                            <label>Tipologia di propriet&agrave;</label>
                            <div style={{marginTop: 12}}>
                              <h4>{item.VehicleOwnershipType.name}</h4>
                            </div>
                          </div>
                        )}

                        <div className="col-md-1 text-left" style={{marginTop: '30px'}}>
                          <a onClick={() => this.onVehicleRemove(index)} className="btn btn-xs btn-danger">Rimuovi</a>
                        </div>
                      </div>
                    )
                  })}
                  <div className="col-md-12 text-center text-danger">
                    {errors}
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="btn btn-green btn-lg-back">
                      Prenota Abbonamento
                    </button>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <div>Dati non disponibili</div>
            )}
          </form>
        </Modal>
      </div>
    )
  }
}

export default reduxForm({
  form: 'waitingListParticipation',
  enableReinitialize: false
})(WaitingLists)



// WEBPACK FOOTER //
// ./src/containers/UserArea/WaitingLists/WaitingLists.js